import { StateReducers } from 'state/reducers/types/StateReducers'
import { CloneTaskButtonConnectedProps } from './types/CloneTaskButtonConnectedProps'
import { CloneTaskButtonMapStateReturnType } from './types/CloneTaskButtonMapStateReturnType'

export const CloneTaskButtonMapState = (
  _state: StateReducers,
  _props: CloneTaskButtonConnectedProps
): CloneTaskButtonMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
